import { AutenticacionService } from '../autenticacion.service';
import { Http, URLSearchParams, ResponseContentType } from '@angular/http';
import { ConstantsService } from '../constants.service';
import { Injectable } from '@angular/core';

@Injectable()
export class ReportesConcentradosService {

  private service_url : string = '';
  constructor(
      private constantsService: ConstantsService, 
      private http: Http, 
      private authService: AutenticacionService) {
    this.service_url = this.constantsService.apiURL + '/reportes/concentrados';
  }

  public general(filters: any, download: boolean = false) {
    let myParams = new URLSearchParams();

    if(filters.fechaInicio){
      myParams.append('fecha-inicio', filters.fechaInicio);
    }

    if(filters.fechaFin){
      myParams.append('fecha-fin', filters.fechaFin);
    }

    if(filters.sucursal){
      myParams.append('sucursal', filters.sucursal);
    }

    let myoptions = this.authService.getAuthHeaders();
    myoptions.params = myParams;
    
    let serviceUrl = this.service_url + '/general';

    if(download){
      myoptions.responseType = ResponseContentType.Blob;
      serviceUrl = this.service_url + '/general/export';
    }
    
    return this.http.get(serviceUrl , myoptions);
  }

  public creditosColocados(filters : any, download: boolean = false) {
    let myParams = new URLSearchParams();

    if(filters.fechaInicio){
      myParams.append('fecha-inicio', filters.fechaInicio);
    }

    if(filters.fechaFin){
      myParams.append('fecha-fin', filters.fechaFin);
    }

    if(filters.sucursal){
      myParams.append('sucursal', filters.sucursal);
    }

    let myoptions = this.authService.getAuthHeaders();
    myoptions.params = myParams;
    
    let serviceUrl = this.service_url + '/creditos-colocados';

    if(download){
      myoptions.responseType = ResponseContentType.Blob;
      serviceUrl = this.service_url + '/creditos-colocados/export';
    }
    
    return this.http.get(serviceUrl , myoptions);
  }

  public pagos(filters : any, download: boolean = false) {
    let myParams = new URLSearchParams();

    if(filters.fechaInicio){
      myParams.append('fecha-inicio', filters.fechaInicio);
    }

    if(filters.fechaFin){
      myParams.append('fecha-fin', filters.fechaFin);
    }

    if(filters.sucursal){
      myParams.append('sucursal', filters.sucursal);
    }

    let myoptions = this.authService.getAuthHeaders();
    myoptions.params = myParams;
    
    let serviceUrl = this.service_url + '/pagos';

    if(download){
      myoptions.responseType = ResponseContentType.Blob;
      serviceUrl = this.service_url + '/pagos/export';
    }
    
    return this.http.get(serviceUrl , myoptions);
  }

}


// WEBPACK FOOTER //
// ./src/app/services/reportes/reportes-concentrados.service.ts